import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation";
import { Table, Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import * as XLSX from "xlsx";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactGA from "react-ga4";
import axios from "axios";
import { mainUrl } from "API/client/api";

const InventoryItems = () => {
  const { userDetail } = useSelector(authenticationSeletor);
  const token = userDetail?.token
  useEffect(() => { ReactGA.send({ hitType: "pageview", page: "inventory_item" }); window.scrollTo(0, 0); getDataHandler(userDetail?.propertyId); getCategoryHandler(userDetail?.propertyId) }, [userDetail]);
  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const [items, setItems] = useState([{ itemName: "", unit: "", price: "" }]);
  const [importByExcelState, setImportByExcelState] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [tableData, setTableData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [category, setCategory] = useState([]);
  const [editPopUp, setEditPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [editData, setEditData] = useState({ editCategory: selectedData.categoryId, editName: selectedData.itemName, editunit: selectedData.unit, editprice: selectedData.price });

  const importByExcel222 = async (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        resolve(data);
      };
      fileReader.onerror = (error) => { reject(error) };
    });
    promise.then((data) => { setExcelData(data) });
  };

  const importByExcel = async (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        try {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const sheetName = "InventoryItems";
          if (!wb.Sheets[sheetName]) {
            alert("InventoryItems sheet not found");
            return;
          }
          const ws = wb.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
          resolve(data);
        } catch (err) {
          reject(err);
        }
      };
      fileReader.onerror = (error) => reject(error);
    });
    promise.then((data) => {
      setExcelData(data);
    });
  };

  const { register, handleSubmit, reset, formState: { errors } } = useForm({ ...validation, mode: "onSubmit" });

  const onSubmit = async (payload) => {
    const realPayload = {
      propertyId: userDetail?.propertyId,
      categoryId: payload.selectCategory,
      createdBy: userDetail?.id,
      items: items,
    };
    const catObj = category.find(c => c.id == payload.selectCategory);
    const updatedItems = items.map(it => ({ ...it, categoryName: catObj?.name || null }));
    try {
      const res = await services.globalService.addInventoryItemService(realPayload);
      if (res.status == 200) {
        reset();
        getDataHandler(userDetail?.propertyId);
        setShow(false);
        setItems([{ itemName: "", unit: "" }]);
        await axios.post(`${mainUrl}api/inventory/inventory-log-create`, { propertyId: userDetail?.propertyId, action: "Create", operation: updatedItems, actionBy: userDetail?.name }, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        })
      }
    } catch (error) { console.log("Error in onSubmit.") }
  };

  const excelSubmit = async () => {
    let count = 0;
    excelData?.map(async (item) => {
      const realPayload = {
        propertyId: userDetail?.propertyId,
        categoryId: item.CategoryIDs?.toString(),
        createdBy: userDetail?.id,
        items: [
          {
            itemName: item.Items,
            unit: item.Unit,
            price: item.Price?.toString(),
            createdBy: userDetail?.id,
          },
        ],
      };
      const catObj = category?.find(c => c?.id == item?.CategoryIDs);
      const updatedItems = realPayload?.items?.map(it => ({ ...it, categoryName: catObj?.name || null }));
      try {
        const res = await services.globalService.addInventoryItemService(realPayload);
        if (res.status == 200) {
          count++;
          await axios.post(`${mainUrl}api/inventory/inventory-log-create`, { propertyId: userDetail?.propertyId, action: "Create", operation: updatedItems, actionBy: userDetail?.name }, {
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          })
        }
      } catch (error) { console.log("Error in excelSubmit function.") }
      if (count == excelData?.length) {
        setExcelData([]);
        setImportByExcelState(false);
        getDataHandler(userDetail?.propertyId);
      }
    });
  };

  const getDataHandler = async (id) => {
    try {
      const res = await services.globalService.getInventoryItemByPropertyIdService(id);
      if (res.status === 200) {
        setTableData(res.data.data);
        setAllData(res.data.data);
      }
    } catch (error) { console.log("Error in getDataHandler function.") }
  };

  const getCategoryHandler = async (id) => {
    try {
      const res = await services.globalService.getInventoryCategoryService(id);
      if (res.status === 200) {
        setCategory(res.data.data);
      }
    } catch (error) { console.log("Error in getCategoryHandler function.") }
  };

  const onError = (error) => { };

  const changeHandler = (e, index) => {
    let tempData = [...items];
    tempData[index][e.target.name] = e.target.value;
    tempData[index].createdBy = userDetail?.id;
    setItems(tempData);
  };

  const closeHandler = (index) => {
    let tempData = [...items];
    tempData.splice(index, 1);
    setItems(tempData);
  };

  const openEditPopUp = (item) => {
    setSelectedData(item);
    setEditPopUp(true);
  };

  const changeEditHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setEditData({ ...editData, [name]: value });
  };

  const formateTable = useRef();

  // const { onDownload: excelDownLoadFormate } = useDownloadExcel({
  //   currentTableRef: formateTable.current,
  //   filename: "bulk_inventory_items.xlsx",
  //   sheet: "InventoryItems",
  // });

  const downloadFormat = () => {
    let units = ["Kg", "Gm", "Lt", "Ml", "Met", "Piece"]
    /* =========================
       SHEET 1 : InventoryItems
    ========================== */
    const inventorySheetData = [
      ["CategoryIDs", "Items", "Unit", "Price"],
      ["", "Spoons", "Piece", 0],
      ["", "Table Spoon", "Piece", 0],
      ["", "Dessert Spoon", "Piece", 0],
      ["", "Soup Spoon", "Piece", 0],
      ["", "Tea Spoon", "Piece", 0],
      ["", "Forks", "Piece", 0],
      ["", "Table Fork", "Piece", 0],
      ["", "Dessert Fork", "Piece", 0],
      ["", "Knives", "Piece", 0],
      ["", "Table Knife", "Piece", 0],
      ["", "Butter Knife", "Piece", 0],
      ["", "Steak Knife (optional)", "Piece", 0],
      ["", "Serving Cutlery", "Piece", 0],
      ["", "Serving Spoon", "Piece", 0],
      ["", "Soup spoon", "Piece", 0],
      ["", "Slotted Serving Spoon", "Piece", 0],
      ["", "Gravy Ladle", "Piece", 0],
      ["", "Soup Ladle", "Piece", 0],
      ["", "Rice Serving Spoon", "Piece", 0],
      ["", "Tongs", "Piece", 0],
      ["", "Plates", "Piece", 0],
      ["", "Full Plate", "Piece", 0],
      ["", "Half Plate", "Piece", 0],
      ["", "Quarter Plate", "Piece", 0],
      ["", "Side Plate", "Piece", 0],
      ["", "Bread Plate", "Piece", 0],
      ["", "Dinner Plate", "Piece", 0],
      ["", "Bowls", "Piece", 0],
      ["", "Veg Bowl", "Piece", 0],
      ["", "Dal Bowl", "Piece", 0],
      ["", "Curry Bowl", "Piece", 0],
      ["", "Soup Bowl", "Piece", 0],
      ["", "Dessert Bowl", "Piece", 0],
      ["", "Rice Bowl", "Piece", 0],
      ["", "Cups & Mugs", "Piece", 0],
      ["", "Tea Cup", "Piece", 0],
      ["", "Saucer", "Piece", 0],
      ["", "Coffee Mug", "Piece", 0],
      ["", "Glassware", "Piece", 0],
      ["", "Water Glass", "Piece", 0],
      ["", "Juice Glass", "Piece", 0],
      ["", "Soft Drink Glass", "Piece", 0],
      ["", "Beer Glass (if allowed)", "Piece", 0],
      ["", "Wine Glass (if allowed)", "Piece", 0],
      ["", "Ashtray (if smoking zone)", "Piece", 0],
      ["", "Condiment Set (Salt & Pepper)", "Piece", 0],
      ["", "Toothpick Holder", "Piece", 0],
      ["", "Butter Dish", "Piece", 0],
      ["", "Sugar Pot", "Piece", 0],
      ["", "Creamer Pot", "Piece", 0],
      ["", "Banquet / Conference", "Piece", 0],
      ["", "Monkey bowl", "Piece", 0],
      ["", "Dustbin", "Piece", 0],
      ["", "Indian bhatti", "Piece", 0],
      ["", "South Indian bhatti", "Piece", 0],
      ["", "Tandoor", "Piece", 0],
      ["", "Deep fridger", "Piece", 0],
      ["", "Fridge", "Piece", 0],
      ["", "Knife", "Piece", 0],
      ["", "Chopping board", "Piece", 0],
      ["", "Chilni", "Piece", 0],
      ["", "Lighter", "Piece", 0],
      ["", "Chapar", "Piece", 0],
      ["", "Chai channi", "Piece", 0],
      ["", "Tea sause pan", "Piece", 0],
      ["", "Belan", "Piece", 0],
      ["", "Palta", "Piece", 0],
      ["", "Dabbu", "Piece", 0],
      ["", "Indian fry pan", "Piece", 0],
      ["", "Chinise fry pan", "Piece", 0],
      ["", "Non stick pan", "Piece", 0],
      ["", "Roti wala tawa", "Piece", 0],
      ["", "Bhagona with dhakkan", "Piece", 0],
      ["", "Praat choti and badi", "Piece", 0],
      ["", "Kisti", "Piece", 0],
      ["", "Roti wali jaali", "Piece", 0],
      ["", "Ek jhaal , puniya", "Piece", 0],
      ["", "Kadhai", "Piece", 0],
      ["", "Garma suprendis", "Piece", 0],
      ["", "Pizza oven", "Piece", 0],
      ["", "Toaster", "Piece", 0],
      ["", "Tea container", "Piece", 0],
      ["", "Soup container", "Piece", 0],
      ["", "Ration container", "Piece", 0],
      ["", "Weight machine", "Piece", 0],
      ["", "Cylinder", "Piece", 0],
      ["", "Warmer", "Piece", 0],
      ["", "Service tray", "Piece", 0],
      ["", "Water serving tray", "Piece", 0],
      ["", "Donga", "Piece", 0],
      ["", "Salad tray", "Piece", 0],
      ["", "Raita bowl", "Piece", 0],
      ["", "RO", "Piece", 0],
      ["", "Bed Sheet (Double)", "Piece", 0],
      ["", "Bed Sheet (Single)", "Piece", 0],
      ["", "Pillow Cover", "Piece", 0],
      ["", "Duvet Cover / Quilt Cover (Double)", "Piece", 0],
      ["", "Duvet Cover / Quilt Cover (Single)", "Piece", 0],
      ["", "Extra Blankets (Double)", "Piece", 0],
      ["", "Extra Blankets (Single)", "Piece", 0],
      ["", "Mattress Protector", "Piece", 0],
      ["", "Hard Pillow", "Piece", 0],
      ["", "Soft Pillow", "Piece", 0],
      ["", "Bed Runner", "Piece", 0],
      ["", "Cushion Cover", "Piece", 0],
      ["", "Cushion", "Piece", 0],
      ["", "Bath Towel", "Piece", 0],
      ["", "Hand Towel", "Piece", 0],
      ["", "Face Towel", "Piece", 0],
      ["", "Bath Mat", "Piece", 0],
      ["", "Bath Robe", "Piece", 0],
      ["", "Table Cloth", "Piece", 0],
      ["", "Napkin / Serviette", "Piece", 0],
      ["", "Place Mat", "Piece", 0],
      ["", "Tray Cloth", "Piece", 0],
      ["", "Tea Towel / Kitchen Towel", "Piece", 0],
      ["", "Laundry Bag", "Piece", 0],
      ["", "Cleaning Cloth / Duster", "Piece", 0],
      ["", "Mop Cloth", "Piece", 0],
      ["", "Chef Apron", "Piece", 0],
      ["", "Chef Coat", "Piece", 0],
      ["", "Chef Cap", "Piece", 0],
      ["", "Linen Cart", "Piece", 0],
      ["", "Toilet Cleaner", "Lt", 0],
      ["", "Glass Cleaner", "Lt", 0],
      ["", "Floor Cleaner", "Lt", 0],
      ["", "Garbage Bag", "Piece", 0],
      ["", "W/C Brush", "Piece", 0],
      ["", "Dry Mop", "Piece", 0],
      ["", "Wet Mop", "Piece", 0],
      ["", "Wiper", "Piece", 0],
      ["", "Bed (Double)", "Piece", 0],
      ["", "Bed (Single)", "Piece", 0],
      ["", "Mattress (Single)", "Piece", 0],
      ["", "Mattress (Double)", "Piece", 0],
      ["", "Bed Sheets", "Piece", 0],
      ["", "Side Table", "Piece", 0],
      ["", "Study Table", "Piece", 0],
      ["", "Chair", "Piece", 0],
      ["", "Wardrobe / Almirah", "Piece", 0],
      ["", "Luggage Rack", "Piece", 0],
      ["", "Mirror", "Piece", 0],
      ["", "Dustbin", "Piece", 0],
      ["", "Curtains / Sheer", "Piece", 0],
      ["", "TV", "Piece", 0],
      ["", "Set-top Box", "Piece", 0],
      ["", "TV Remote", "Piece", 0],
      ["", "Set Up Box Remote", "Piece", 0],
      ["", "AC Remote", "Piece", 0],
      ["", "AC", "Piece", 0],
      ["", "Heater", "Piece", 0],
      ["", "Telephone", "Piece", 0],
      ["", "Kettle Set", "Piece", 0],
      ["", "Wash Basin", "Piece", 0],
      ["", "WC / Commode", "Piece", 0],
      ["", "Shower", "Piece", 0],
      ["", "Geyser", "Piece", 0],
      ["", "Mirror (Bathroom)", "Piece", 0],
      ["", "Towel Rod / Ring", "Piece", 0],
      ["", "Soap Dish", "Piece", 0],
      ["", "Toothbrush Holder", "Piece", 0],
      ["", "Bath Towels", "Piece", 0],
      ["", "Dustbin (Bathroom)", "Piece", 0],
      ["", "Toiletries Tray", "Piece", 0],
      ["", "Housekeeping Trolley", "Piece", 0],
      ["", "Mop Set", "Piece", 0],
      ["", "Bucket", "Piece", 0],
      ["", "Spray Bottles", "Piece", 0],
      ["", "Vacuum Cleaner", "Piece", 0],
      ["", "Dining Table", "Piece", 0],
      ["", "Chairs", "Piece", 0],
      ["", "Table Cloth", "Piece", 0],
      ["", "Napkins", "Piece", 0],
      ["", "Plates (Veg / Non-veg)", "Piece", 0],
      ["", "Bowls", "Piece", 0],
      ["", "Glasses", "Piece", 0],
      ["", "Cups & Saucers", "Piece", 0],
      ["", "Cutlery Set", "Piece", 0],
      ["", "Serving Tray", "Piece", 0],
      ["", "Buffet Counter", "Piece", 0],
      ["", "Chafing Dish", "Piece", 0],
      ["", "Washing Machine", "Piece", 0],
      ["", "Dryer", "Piece", 0],
      ["", "Iron", "Piece", 0],
      ["", "Iron Table", "Piece", 0],
      ["", "Laundry Basket", "Piece", 0],
      ["", "Folding Table", "Piece", 0],
      ["", "Detergent Containers", "Piece", 0],
      ["", "Fire Extinguisher", "Piece", 0],
      ["", "Fire Alarm", "Piece", 0],
      ["", "Emergency Light", "Piece", 0],
      ["", "CCTV Camera", "Piece", 0],
      ["", "DVR / Monitor", "Piece", 0],
      ["", "First Aid Box", "Piece", 0],
      ["", "Computer / Laptop", "Piece", 0],
      ["", "Printer", "Piece", 0],
      ["", "Register Files", "Piece", 0],
      ["", "Key Cards / Keys", "Piece", 0],
      ["", "Cash Drawer", "Piece", 0],
      ["", "Bell Desk Trolley", "Piece", 0],
      ["", "Visitor Chairs", "Piece", 0],
      ["", "Tool Kit", "Piece", 0],
      ["", "Ladder", "Piece", 0],
      ["", "Electrical Items", "Piece", 0],
      ["", "Plumbing Tools", "Piece", 0],
      ["", "Spare Bulbs", "Piece", 0],
      ["", "Extension Board", "Piece", 0]
    ];
    const inventorySheet = XLSX.utils.aoa_to_sheet(inventorySheetData);
    inventorySheet["!cols"] = [{ wch: 18 }, { wch: 25 }, { wch: 30 }, { wch: 12 }];
    ["A1", "B1", "C1", "D1"].forEach(cell => {
      inventorySheet[cell].s = { fill: { fgColor: { rgb: "FF000000" } }, font: { bold: true, color: { rgb: "FFFFFFFF" } } };
    });

    /* =========================
       SHEET 2 : Categories
    ========================== */
    const categorySheetData = [["Category IDs", "Category Name"], ...category.map((cat) => [String(cat.id), cat.name])];
    const categorySheet = XLSX.utils.aoa_to_sheet(categorySheetData);
    categorySheet["!cols"] = [{ wch: 18 }, { wch: 30 }];
    ["A1", "B1"].forEach(cell => {
      categorySheet[cell].s = { fill: { fgColor: { rgb: "FF000000" } }, font: { bold: true, color: { rgb: "FFFFFFFF" } } };
    });

    /* =========================
       SHEET 3 : Units
    ========================== */
    const unitSheetData = [["Unit Name"], ...units.map((un) => [un])];
    const unitSheet = XLSX.utils.aoa_to_sheet(unitSheetData);
    unitSheet["!cols"] = [{ wch: 22 }];
    unitSheet["A1"].s = { fill: { fgColor: { rgb: "FF000000" } }, font: { bold: true, color: { rgb: "FFFFFFFF" } } };

    /* =========================
       WORKBOOK
    ========================== */
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, inventorySheet, "InventoryItems");
    XLSX.utils.book_append_sheet(workbook, categorySheet, "Categories");
    XLSX.utils.book_append_sheet(workbook, unitSheet, "Units");
    XLSX.writeFile(workbook, "bulk_inventory_items.xlsx");
  };

  // const editSubmit = async () => {
  //   try {
  //     const bodyData = {
  //       itemName: editData?.editName ?? selectedData?.itemName,
  //       propertyId: userDetail?.propertyId,
  //       categoryId: editData?.editCategory ?? selectedData?.categoryId,
  //       unit: editData?.editunit ?? selectedData?.unit,
  //       price: editData?.editprice ?? selectedData?.price,
  //       createdBy: userDetail?.id,
  //     };
  //     let res = await services.property.updateInventoryItemByFoodId(selectedData?.id, bodyData)
  //     if (res?.status == 200) {
  //       setEditPopUp(false);
  //       getDataHandler(userDetail?.propertyId);
  //       const catObj = category?.find(c => c?.id == payload?.selectCategory);
  //       const updatedItems = items?.map(it => ({ ...it, categoryName: catObj?.name || null }));
  //       await axios.post(`${mainUrl}api/inventory/inventory-log-create`, { propertyId: userDetail?.propertyId, action: "Update", operation: updatedItems, actionBy: userDetail?.name }, {
  //         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  //       })
  //     }
  //   } catch (error) { console.log("Error in editSubmit.") }
  // };

  const editSubmit = async () => {
    try {
      const bodyData = {
        itemName: editData?.editName ?? selectedData?.itemName,
        propertyId: userDetail?.propertyId,
        categoryId: editData?.editCategory ?? selectedData?.categoryId,
        unit: editData?.editunit ?? selectedData?.unit,
        price: editData?.editprice ?? selectedData?.price,
        createdBy: userDetail?.id,
      };

      const newCategory = category?.find(c => c?.id == bodyData?.categoryId);
      const oldCategory = category?.find(c => c?.id == selectedData?.categoryId);
      const operationArr = [
        {
          itemName: bodyData?.itemName,
          oldItemName: selectedData?.itemName,
          unit: bodyData?.unit,
          oldUnit: selectedData?.unit,
          price: bodyData?.price,
          oldPrice: selectedData?.price,
          createdBy: bodyData?.createdBy,
          categoryName: newCategory?.name || null,
          oldCategoryName: oldCategory?.name || null
        }
      ];

      const res = await services.property.updateInventoryItemByFoodId(selectedData?.id, bodyData);
      if (res?.status == 200) {
        setEditPopUp(false);
        await getDataHandler(userDetail?.propertyId);
        await axios.post(
          `${mainUrl}api/inventory/inventory-log-create`,
          {
            propertyId: userDetail?.propertyId,
            action: "Update",
            operation: operationArr,
            actionBy: userDetail?.name,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
          }
        );
        console.log("Inventory Updated + Log Saved Successfully");
      }
    } catch (error) { console.log("Error in editSubmit function.") }
  };

  const searchfilter = (text) => {
    if (text == "") return setTableData(allData);
    const resultsData = allData.filter((order) => {
      return (order.InventoryCategory?.name + order?.itemName + order?.quantity)?.toString().toLowerCase()?.includes(text?.toLowerCase())
    });
    setTableData(resultsData);
  };

  const [logs, setLogs] = useState([])
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [action, setAction] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const extraBtnHandler = async (page = 1, pageLimit = limit) => {
    try {
      const res = await axios.get(
        `${mainUrl}api/inventory/administration-logs/${userDetail?.propertyId}?page=${page}&limit=${pageLimit}&action=${action}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
        }
      );
      setLogs(res.data.data);
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.currentPage);
      setTotalCount(res.data.total);
    } catch (error) {
      console.log("Error in extraBtnHandler function");
    }
  };

  useEffect(() => { if (showLog) extraBtnHandler(1, limit); }, [action, limit]);

  return (
    <Layout title="Inventory Items" openHandler={() => setShow(true)} searchPlaceHolder="Search" secondBtn={() => setImportByExcelState(true)} secondbuttonTitle="Import Table" searchType="search" searchfilter={searchfilter} extraButton="View Log" extraBtnHandler={() => { setShowLog(true); extraBtnHandler() }} >
      <Table striped bordered hover className="common-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Item</th>
            <th>Price</th>
            <th>Unit</th>
            {userDetail?.Role?.canEdit == 1 && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {tableData.map((data, key) => (
            <tr key={key}>
              <td>{data?.InventoryCategory?.name}</td>
              <td>{data?.itemName}</td>
              <td>{data?.price ? '₹ ' + data?.price : '-'}</td>
              <td>{data?.unit}</td>
              {userDetail?.Role?.canEdit == 1 && (
                <td>
                  <Button variant="primary" onClick={() => openEditPopUp(data)} className="btn-sm">
                    <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={show} onHide={() => { setShow(false); reset(); setItems([{ itemName: "", unit: "" }]) }} size="lg">
        <Modal.Header closeButton><Modal.Title>Create Inventory Item</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm" onSubmit={handleSubmit(onSubmit, onError)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <label>Select Category</label>
                  <select register={register} {...register("selectCategory")}>
                    <option selected disabled>Select</option>
                    {category.map((data) => (<option value={data.id}>{data.name}</option>))}
                  </select>
                  {errors?.selectCategory?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"selectCategory"} /></span>
                    </div>
                  )}
                </Col>
                {items.map((data, i) => (
                  <Col xs={12} className="addItems">
                    <Row>
                      {items.length > 1 ? (
                        <Col xs={12}>
                          <div className="cutIcon" onClick={() => closeHandler(i)}><i className="fa fa-times" aria-hidden="true"></i></div>
                        </Col>
                      ) : null}
                      <Col xs={6} className="form-group">
                        <label>Item Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter item name"
                          value={data.itemName}
                          onChange={(e) => changeHandler(e, i)}
                          name="itemName"
                        />
                      </Col>
                      <Col xs={6} className="form-group">
                        <label>Item Price</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter item Price"
                          value={data.price}
                          onChange={(e) => changeHandler(e, i)}
                          name="price"
                        />
                      </Col>
                      <Col xs={6} className="form-group">
                        <label>Select Unit</label>
                        <select
                          value={data.unit}
                          onChange={(e) => changeHandler(e, i)}
                          name="unit"
                        >
                          <option selected disabled value={""}>
                            Select
                          </option>
                          <option>Kg</option>
                          <option>Gm</option>
                          <option>Lt</option>
                          <option>Ml</option>
                          <option>Met</option>
                          <option>Piece</option>
                        </select>
                      </Col>
                    </Row>
                  </Col>
                ))}

                <Col
                  xs={12}
                  className="form-group flex justify-content-between mt-2 align-center"
                >
                  <Button
                    variant="primary"
                    type="button"
                    className="buttonCenter"
                    onClick={() =>
                      setItems([...items, { itemName: "", unit: "" }])
                    }
                  >
                    + Add Item
                  </Button>
                </Col>
                <Col
                  xs={12}
                  className="form-group flex justify-content-between mt-4"
                >
                  <Button
                    className="greyBtn"
                    variant="outline-primary"
                    onClick={() => {
                      setShow(false);
                      reset();
                      setItems([{ itemName: "", unit: "" }]);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={editPopUp} onHide={() => { setEditPopUp(!editPopUp); reset(); setItems([{ itemName: "", unit: "", price: "" }]) }} size="lg">
        <Modal.Header closeButton><Modal.Title>Edit Inventory Item</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm" onSubmit={handleSubmit(onSubmit, onError)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <label>Select Category</label>
                  <select name="editCategory" onChange={(e) => changeEditHandler(e)}>
                    <option selected disabled>Select</option>
                    {category.map((data) => (
                      <option value={data.id} selected={data?.id == selectedData?.categoryId}>{data.name}</option>
                    ))}
                  </select>
                  {errors?.selectCategory?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"selectCategory"} /></span>
                    </div>
                  )}
                </Col>
                {items.map((data, i) => (
                  <Col xs={12} className="addItems">
                    <Row>
                      {items.length > 1 ? (
                        <Col xs={12}>
                          <div
                            className="cutIcon"
                            onClick={() => closeHandler(i)}
                          >
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </div>
                        </Col>
                      ) : null}
                      <Col xs={12} className="form-group">
                        <label>Item Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter item name"
                          value={editData?.editName ?? selectedData?.itemName}
                          onChange={(e) => changeEditHandler(e)}
                          name="editName"
                        />
                      </Col>
                      <Col xs={6} className="form-group">
                        <label>Item Price</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter item Price"
                          value={editData?.editprice ?? selectedData?.price}
                          onChange={(e) => changeEditHandler(e, i)}
                          name="editprice"
                        />
                      </Col>
                      <Col xs={6} className="form-group">
                        <label>Select Unit</label>
                        <select
                          value={editData?.editunit ?? selectedData?.unit}
                          onChange={(e) => changeEditHandler(e)}
                          name="editunit"
                        >
                          <option selected disabled value={""}>
                            Select
                          </option>
                          <option>Kg</option>
                          <option>Gm</option>
                          <option>Lt</option>
                          <option>Ml</option>
                          <option>Met</option>
                          <option>Piece</option>
                        </select>
                      </Col>
                      {/* <Col xs={6} className="form-group">
                        <label>Item price</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter item price"
                          value={editData?.editprice ?? selectedData?.price}
                          onChange={(e) => changeEditHandler(e)}
                          name="editprice"
                        />
                      </Col> */}
                    </Row>
                  </Col>
                ))}

                <Col
                  xs={12}
                  className="form-group flex justify-content-between mt-2 align-center"
                >
                  {/* <Button
                    variant="primary"
                    type="button"
                    className="buttonCenter"
                    onClick={() =>
                      setItems([
                        ...items,
                        { itemName: "", unit: "", price: "" },
                      ])
                    }
                  >
                    + Add Item
                  </Button> */}
                </Col>
                <Col
                  xs={12}
                  className="form-group flex justify-content-between mt-4"
                >
                  <Button
                    className="greyBtn"
                    variant="outline-primary"
                    onClick={() => {
                      setEditPopUp(false);
                      reset();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="button" onClick={editSubmit}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={importByExcelState} onHide={() => { setImportByExcelState(false); setExcelData([]) }} size="lg">
        <Modal.Header closeButton><Modal.Title>Import Bulk Items</Modal.Title></Modal.Header>
        <Modal.Body>
          {excelData?.length > 0 ? (
            <>
              <div className="flex justify-content-end mb-2">
                <button className="btn-sm btn-primary" onClick={excelSubmit}>Submit</button>
              </div>
              <Table striped bordered hover className="common-table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Category</th>
                    <th>Item Name</th>
                    <th>Unit</th>
                    <th>Item Price</th>
                  </tr>
                </thead>
                <tbody>
                  {excelData?.map((data, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-center">{key + 1}</td>
                        <td>{data.CategoryIDs}</td>
                        <td>{data.Items}</td>
                        <td>{data.Unit}</td>
                        <td>₹{data.Price}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          ) : (
            <div className="flex gap-1 justify-content-between align-items-center ">
              <div className="flex form-group flex-column ">
                <label htmlFor="excel">Select Excel File</label>
                <input type="file" id="excel" onChange={(e) => importByExcel(e.target.files[0])} />
              </div>
              <button className="btn-sm btn-primary text-white" onClick={downloadFormat}>Download Formate</button>
              <table className="table border" ref={formateTable} style={{ position: "absolute", top: -100000000000 }}>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Items</th>
                    <th>Unit</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Category Ids</td>
                    <td>items name</td>
                    <td>Kg/gm/lt</td>
                    <td>Only Number</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showLog} onHide={() => { setShowLog(false); setTotalPages(1); setTotalCount(0); setAction("All"); setCurrentPage(1); setLimit(10) }} size="xl">
        <Modal.Header closeButton><Modal.Title>Inventory Item Logs</Modal.Title></Modal.Header>
        <Modal.Body style={{ height: "80vh", overflowY: "scroll" }}>
          {(() => {
            const filteredLogs = activeTab == "All" ? logs : logs?.filter((log) => log.action?.toLowerCase() == activeTab.toLowerCase());
            return (
              <div className="p-3">
                <div className="d-flex gap-2 mb-3">
                  {["All", "create", "update"].map((tab) => (
                    <button
                      key={tab}
                      className={`btn ${activeTab == tab ? "btn-primary" : "btn-outline-primary"} rounded-pill px-3`}
                      style={{ borderRadius: "30px" }}
                      onClick={() => { setActiveTab(tab); setAction(tab); extraBtnHandler(1, limit) }}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div>
                <div className="d-flex justify-content-between align-items-center alert alert-info py-2 mb-3">
                  <div>Showing {logs?.length} of {totalCount} logs </div>
                  <select
                    className="form-select"
                    style={{ width: "120px" }}
                    value={limit}
                    onChange={(e) => { const newLimit = Number(e.target.value); setLimit(newLimit); extraBtnHandler(1, newLimit) }}
                  >
                    <option value="5">5 / page</option>
                    <option value="10">10 / page</option>
                    <option value="20">20 / page</option>
                    <option value="50">50 / page</option>
                  </select>
                </div>
                <div className="table-responsive logs-table">
                  <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Action</th>
                        <th>Snapshot</th>
                        <th>Action By</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLogs?.length > 0 ? (
                        filteredLogs.map((row, index) => (
                          <tr key={row.id}>
                            <td>{index + 1}</td>
                            <td><span className="badge" style={{ background: row.action == "update" ? "orange" : row.action == "create" ? "green" : "#6c757d", color: "white" }}>{row.action}</span></td>
                            <td>
                              <div
                                style={{
                                  background: "#f9fafb",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  maxHeight: "220px",
                                  overflowY: "auto",
                                  fontSize: "13px",
                                  color: "#333",
                                }}
                              >
                                {(() => {
                                  let data = row.operation;

                                  // Convert string to array if needed
                                  if (typeof data === "string") {
                                    try {
                                      data = JSON.parse(data);
                                    } catch (e) {
                                      return <div style={{ color: "red" }}>Invalid JSON</div>;
                                    }
                                  }

                                  // If not array, wrap into array
                                  if (!Array.isArray(data)) data = [data];

                                  return data.map((item, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        background: "#fff",
                                        padding: "10px",
                                        marginBottom: "8px",
                                        borderRadius: "8px",
                                        border: "1px solid #e5e7eb",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                                      }}
                                    >
                                      <div><strong>Item:</strong> {item.itemName}{" "}{item.oldItemName && (
                                        <span style={{ color: "blue" }}> (Old: {item.oldItemName})</span>
                                      )}</div>

                                      <div>
                                        <strong>Unit:</strong> {item.unit}{" "}
                                        {item.oldUnit && (
                                          <span style={{ color: "blue" }}> (Old: {item.oldUnit})</span>
                                        )}
                                      </div>

                                      <div>
                                        <strong>Price:</strong> {item.price}{" "}
                                        {item.oldPrice != null && (
                                          <span style={{ color: "blue" }}> (Old: {item.oldPrice})</span>
                                        )}
                                      </div>

                                      <div>
                                        <strong>Category:</strong> {item.categoryName}{" "}
                                        {item.oldCategoryName && (
                                          <span style={{ color: "blue" }}>
                                            (Old: {item.oldCategoryName})
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  ));
                                })()}
                              </div>
                            </td>

                            <td>{row.actionBy || "-"}</td>
                            <td>{new Date(row.createdAt).toLocaleString()}</td>
                          </tr>
                        ))
                      ) : (<tr><td colSpan="7" className="text-center py-3">No logs found</td></tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}
          <div className="d-flex justify-content-between align-items-center px-3 mb-3">
            <button
              className="btn btn-outline-primary"
              disabled={currentPage == 1}
              onClick={() => extraBtnHandler(currentPage - 1, limit)}
            >
              ← Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary"
              disabled={currentPage == totalPages}
              onClick={() => extraBtnHandler(currentPage + 1, limit)}
            >
              Next →
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer><Button className="greyBtn" variant="outline-primary" onClick={() => { setShowLog(false); setTotalPages(1); setTotalCount(0); setAction("All"); setCurrentPage(1); setLimit(10) }}>Close</Button></Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default InventoryItems;
